import { render, staticRenderFns } from "./AddModule.vue?vue&type=template&id=ba056398&scoped=true"
import script from "./AddModule.vue?vue&type=script&lang=js"
export * from "./AddModule.vue?vue&type=script&lang=js"
import style0 from "./AddModule.vue?vue&type=style&index=0&id=ba056398&prod&lang=scss&scoped=true"
import style1 from "./AddModule.vue?vue&type=style&index=1&id=ba056398&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba056398",
  null
  
)

export default component.exports